<template>
  <div>
    <v-list>
      <p
        class="subheading grey--text text--darken-2 mt-2 ml-3 font-weight-bold"
        align="left"
      >Scarlets Portal</p>
      <template v-for="level1Menu in filterMenuByLevel('1')">
        <v-list-tile
          v-if="level1Menu.menuAction === 'none' && level1Menu.userLevel <= user.userLevel"
          :key="level1Menu.id"
          value="true"
          sub-group
        >
          <v-list-tile-action>
            <v-icon class="level2MenuIcon grey--text text--lighten-1 ml-4">{{level1Menu.icon}}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title
              class="grey--text text--lighten-1 font-weight-normal"
              v-text="level1Menu.alias"
            ></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile
          v-if="level1Menu.menuAction === 'link' && parseInt(level1Menu.userLevel) <= parseInt(user.userLevel)"
          :key="level1Menu.id"
          value="true"
          sub-group
          :to="level1Menu.path"
        >
          <v-list-tile-action>
            <v-icon class="level1MenuIcon">{{ level1Menu.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-text="level1Menu.alias"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-group
          v-if="level1Menu.menuAction === 'dropdown' && parseInt(level1Menu.userLevel) <= parseInt(user.userLevel) "
          :key="level1Menu.id"
          :prepend-icon="level1Menu.icon"
        >
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-title>{{ level1Menu.alias }}</v-list-tile-title>
            </v-list-tile>
          </template>

          <template v-for="level2Menu in filterMenuByParentandLevel(level1Menu.id, '2')">
            <v-list-tile
              v-if="level2Menu.menuAction === 'none' && user.userLevel >= level2Menu.userLevel"
              :key="level2Menu.id"
              sub-group
            >
              <v-list-tile-action />
              <v-list-tile-title class="font-weight-normal" v-text="level2Menu.alias"></v-list-tile-title>
              <v-list-tile-action>
                <v-icon class="level2MenuIcon grey--text text--lighten-1 ml-4">{{ level2Menu.icon }}</v-icon>
              </v-list-tile-action>
            </v-list-tile>

            <v-list-tile
              v-if="level2Menu.menuAction === 'link' && parseInt(user.userLevel) >= parseInt(level2Menu.userLevel)"
              :key="level2Menu.id"
              class="pointer"
              sub-group
              :to="level2Menu.path"
            >
              <v-list-tile-action />
              <v-list-tile-title v-text="level2Menu.alias"></v-list-tile-title>
              <v-list-tile-action v-if="level2Menu.icon !== 'blank'">
                <v-icon class="level2MenuIcon grey--text text--lighten-1 ml-4">{{ level2Menu.icon }}</v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </template>
        </v-list-group>
      </template>
    </v-list>
   
  </div>
</template>



<script>
import { mapState } from "vuex";
export default {
  data: () => ({
    currentPortal: {}
  }),
  computed: {
    ...mapState({
      Menu: state => state.Menu.Items,
      Portals: state => state.Admin.Portals,
      portal: state => state.portal.active, // Currently active portal
      user: state => state.user.active
    })
  },
  watch: {
    portal: {
      handler: function() {
        //console.log("this.portal.id = " + this.portal.id);
        this.updateMenu();
      },
      deep: true // looks deep into object for changes
    }
  },
  mounted() {
    this.updateMenu();
    this.$store.dispatch("Admin/readPortals"); // Update Admin Store with List of portal from DB
  },
  methods: {
    updateMenu() {
      this.$store.dispatch("Menu/readMenu", [
        "menus",
        this.portal.id,
        "Menu/setMenu"
      ]);
    },
    filterMenuByLevel: function(menuLevel) {
      var Menu = this.$filter(this.Menu, { menuLevel: menuLevel });
      Menu = this.$sortBy(Menu, function(level1Menu) {
        return parseInt(level1Menu.order, 10);
      });
      return Menu;
    },
    filterMenuByParentandLevel: function(id, menuLevel) {
      var Menu = this.filterMenuByLevel(menuLevel);
      Menu = this.$filter(Menu, { parent: id });
      return Menu;
    }
  }
};
</script>

<style>
.level2MenuIcon {
  font-size: 21px !important;
  font-weight: normal !important;
}
.level3MenuIcon {
  font-size: 21px !important;
  font-weight: normal !important;
}
</style>